export interface StateProps {
    // state
    _auth: {
        user: User;
        token: string;
        isLoggedIn: boolean;
    };
    _data: {
        phones: any;
        cart: Cart;
        item: Item;
        order: Order;
        options: any;
        filter: any;
        settings: {
            roles: any[];
            countries: Country[];
        };
        categories: Category[];
        filterDefault: any;
        active_venue: Store;
        paymentOptions: any;
        orderStatus: any;
        promo_cart: any;
        cartDefault: any;
        location: { x: number; y: number };
    };
    // redux
    dispatch: any;
    changeAuth: (key: string, value: any) => void;
    changeData: (key: string, value: any) => void;
    setAuthenticated: any;
}

export interface AxiusResponse {
    count: number;
    data: any;
    token: string;
    status: number;
    message: string;
    pay: any;
    meta: {
        limit: number;
        next: string;
        previous: string;
        total: number;
    };
}

export interface OrdersFilter {
    status?: number;
}

export enum OrderStatus {
    NEW = 'NEW',
    ACCEPTED = 'ACCEPTED',
    PREPARING = 'PREPARING',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    TIMEOUT = 'TIMEOUT',
    DELIVERY = 'DELIVERY',
    PAYMENT = 'PAYMENT',
    READY = 'READY',
    ARRIVED = 'ARRIVED',
    PICKUP = 'PICKUP',
    UNCLAIMED = 'UNCLAIMED',
    RIDER_PENDING = 'RIDER_PENDING',
    RIDER_UNAVAILABLE = 'RIDER_UNAVAILABLE',
}

export interface Category {
    id?: number;
    uuid: string;
    name: string;
    createdAt: string;
    sequence: number;
    delivery: number;
    updatedAt: string;
    store: string;
    price: number;
}

export interface Country {
    callingCode: string;
    code: string;
    currency: string;
    decimal: number;
    name: string;
    phoneLength: number;
}

export interface Item {
    can_deliver: number;
    createdAt: string;
    description: string;
    distance: number;
    id: number;
    images: string[];
    imagesLinks: string[];
    name: string;
    preparationTime: string;
    price: number;
    status: string;
    updatedAt: string;
    uuid: string;
    variants: Record<string, Variant[]>;
    store: any;
    drinks: [];
    freeSides: [];
    paidSides: [];
    quantity: number;
    priceTotal: number;
}

export interface Variant {
    code: string;
    name: string;
    price: number;
    quantity: number;
}


export interface Store {
    address: Address;
    bank: [];
    country: Country;
    cover: string;
    coverLink: string;
    createdAt: string;
    delivery: {
        cart_minimum: number;
        fee: number;
        fee_type: string;
        options: string[];
        radius: number;
        schedule: {
            to: string;
            from: string;
        }
    };
    description: string;
    distance: number;
    email: string;
    id: number;
    logo: string;
    logo_link: string;
    name: string;
    paymentOptions: string;
    phoneNumber: string;
    preferences: Preferences;
    schedule: Schedule[];
    slug: string;
    status: string;
    updatedAt: string;
    uuid: string;
    store: string;
}

export interface Country {
    callingCode: string;
    code: string;
    currency: string;
    decimal: number;
    name: string;
    phoneLength: number;
}

export interface Schedule {
    available: boolean;
    closing: string;
    day: string;
    opening: string;
}

export interface Address {
    iso: string;
    x: number;
    y: number;
    name: string;
    state: string;
    zoom: number;
    address: string;
}

export enum OrderPaymentTypes {
    ADVANCE = 'ADVANCE',
    DELIVERY = 'DELIVERY',
    WALLET = 'WALLET',
}

export interface Order {
    address: Address;
    amount: {
        amount: number;
        delivery: number;
        total: number;
    };
    cancellation: any;
    code: string;
    createdAt: any;
    delivery: {
        channel: string;
        instructions: string;
    };
    id: number;
    items: Item[];
    origin: string;
    paymentToken: string;
    paymentType: OrderPaymentTypes;
    reviews: {
        id: number;
        comment: string;
        deliveryChannel: string;
        deliveryRate: number;
        mealRate: number;
        user: User;
    }[];
    status: OrderStatus;
    statusHistory: Record<string, OrderStatus>;
    type: string;
    updatedAt: string;
    user: User;
    uuid: string;
    store: Store;
    riders: {
        id: string;
        reason: string;
        status: OrderStatus;
        userId: string;
        name: string;
        email: string;
        createdAt: any;
    }[];
}

export interface User {
    address: Address;
    avatar: string;
    avatar_link: string;
    birthDate: string;
    country: Country;
    createdAt: string;
    email: string;
    firstName: string;
    gender: UserGenders;
    id: string;
    lastName: string;
    name: any;
    phoneNumber: string;
    preferences: Preferences;
    push_ids: string;
    role: any;
    roleId: string;
    status: string;
    subscription: any;
    type: string;
    updatedAt: string;
}

export enum UserGenders {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export interface Cart {
    delivery: {
        channel: string;
    }
    deliveryFee: number;
    items: Item[];
    paymentType: OrderPaymentTypes;
    store: Store;
}

export interface Preferences {
    online: boolean;
    offlineFor: number;
    offlineAt: string;
    sidesAvailable: string[];
    canTakeOrders: boolean;
}